import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../i18n';

const FormTemplatesCustomPickerNoSearchResults = ({ clearFilters }) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CLIPBOARD_WEATHER_GREY}
      title={t('NO_FORM_TEMPLATES_FOUND')}
      description={t('TRY_SEARCH_AGAIN')}
    >
      <LinkButton onClick={clearFilters}>{t('CLEAR_SEARCH')}</LinkButton>
    </EmptyState>
  );
};

export default FormTemplatesCustomPickerNoSearchResults;
